export const TypeUser = {
  admin: 1,
  client: 2,
  seller: 3,
  unity_responsible: 4,
  stockist: 5,
};
